module.exports = __webpack_public_path__ + "static/media/ios-arrow-down.7263e94f.svg";